// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function variant_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var sku = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sku"), null));
  if (sku.TAG === /* Ok */0) {
    var size_code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "size_code"), null));
    if (size_code.TAG === /* Ok */0) {
      var is_active = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_active"), null));
      if (is_active.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  sku: sku._0,
                  size_code: size_code._0,
                  is_active: is_active._0
                }
              };
      }
      var e = is_active._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".is_active" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = size_code._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".size_code" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = sku._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".sku" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function productImage_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var image_url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image_url"), null));
  if (image_url.TAG === /* Ok */0) {
    var display_order = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "display_order"), null));
    if (display_order.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                image_url: image_url._0,
                display_order: display_order._0
              }
            };
    }
    var e = display_order._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".display_order" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = image_url._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".image_url" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function pricing_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var list_amount_minor = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "list_amount_minor"), null));
  if (list_amount_minor.TAG === /* Ok */0) {
    var sale_amount_minor = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sale_amount_minor"), null));
    if (sale_amount_minor.TAG === /* Ok */0) {
      var currency_code = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currency_code"), null));
      if (currency_code.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  list_amount_minor: list_amount_minor._0,
                  sale_amount_minor: sale_amount_minor._0,
                  currency_code: currency_code._0
                }
              };
      }
      var e = currency_code._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".currency_code" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = sale_amount_minor._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sale_amount_minor" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = list_amount_minor._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".list_amount_minor" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function product_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "code"), null));
  if (code.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
      if (description.TAG === /* Ok */0) {
        var is_active = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_active"), null));
        if (is_active.TAG === /* Ok */0) {
          var images = Decco.optionFromJson((function (param) {
                  return Decco.arrayFromJson(productImage_decode, param);
                }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "images"), null));
          if (images.TAG === /* Ok */0) {
            var variants = Decco.arrayFromJson(variant_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "variants"), null));
            if (variants.TAG === /* Ok */0) {
              var has_validation = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "has_validation"), null));
              if (has_validation.TAG === /* Ok */0) {
                var pricing = Decco.optionFromJson(pricing_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pricing"), null));
                if (pricing.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            code: code._0,
                            name: name._0,
                            description: description._0,
                            is_active: is_active._0,
                            images: images._0,
                            variants: variants._0,
                            has_validation: has_validation._0,
                            pricing: pricing._0
                          }
                        };
                }
                var e = pricing._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".pricing" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = has_validation._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".has_validation" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = variants._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".variants" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = images._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".images" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = is_active._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".is_active" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = description._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".description" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = code._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".code" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function validationConfig_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var product_code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "product_code"), null));
  if (product_code.TAG === /* Ok */0) {
    var required_quantity = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "required_quantity"), null));
    if (required_quantity.TAG === /* Ok */0) {
      var error_message = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "error_message"), null));
      if (error_message.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  product_code: product_code._0,
                  required_quantity: required_quantity._0,
                  error_message: error_message._0
                }
              };
      }
      var e = error_message._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".error_message" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = required_quantity._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".required_quantity" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = product_code._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".product_code" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function validation_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var type_ = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "type"), null));
  if (type_.TAG === /* Ok */0) {
    var config = validationConfig_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "config"), null));
    if (config.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                type_: type_._0,
                config: config._0
              }
            };
    }
    var e = config._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".config" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = type_._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".type" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var products = Decco.arrayFromJson(product_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "products"), null));
  if (products.TAG === /* Ok */0) {
    var validations = Decco.optionFromJson((function (param) {
            return Decco.arrayFromJson(validation_decode, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "validations"), null));
    if (validations.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                products: products._0,
                validations: validations._0
              }
            };
    }
    var e = validations._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".validations" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = products._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".products" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

export {
  variant_decode ,
  productImage_decode ,
  pricing_decode ,
  product_decode ,
  validationConfig_decode ,
  validation_decode ,
  t_decode ,
  
}
/* No side effect */
